import type { Location } from './types';

export const LOAD_LOCATIONS_SUCCESS = 'LOAD_LOCATIONS_SUCCESS';
export const loadLocationsSuccess = (locations: Location[]) => ({
  type: LOAD_LOCATIONS_SUCCESS,
  locations,
});

export const UPDATE_LOCATION_SUCCESS = 'UPDATE_LOCATION_SUCCESS';
export const updateLocationSuccess = (location: Location) => ({
  type: UPDATE_LOCATION_SUCCESS,
  location,
});
